import { useState, useId } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { useTranslation } from "react-i18next";

const IconLink = ({
    label,
    icon,
    focusIcon,
    showLabel,
    href,
    external,
    color,
    hasHoverColor = false,
    hoverColor,
    tooltipPlace = "top-start",
}) => {
    const { t } = useTranslation();
    const [focus, setFocus] = useState(false);
    if (hasHoverColor)
        hoverColor = `icon-button-hover--${hoverColor || "bleu-a2"}`;

    const id = `iconLink-${useId().replace(/[:]/g, "")}`;

    return external ? (
        <a
            target="_blank"
            rel="noreferrer"
            data-tip={t(label)}
            className={`icon-button icon-button--${color || "bleu-a2"} ${hoverColor}`}
            href={href}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            onMouseEnter={() => setFocus(true)}
            onMouseLeave={() => setFocus(false)}
        >
            <i className={focus ? focusIcon : icon}></i>
            <span className={showLabel ? "" : "sr-only"}>{t(label)}</span>
        </a>
    ) : (
        <Link
            data-tip={t(label)}
            className={`icon-button icon-button--${color || "bleu-a2"} ${hoverColor}`}
            to={href}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            onMouseEnter={() => setFocus(true)}
            onMouseLeave={() => setFocus(false)}
            data-tooltip-id={id}
            data-tooltip-content={t(label)}
        >
            <i className={focus ? focusIcon : icon}></i>
            <span className={showLabel ? "" : "sr-only"}>{t(label)}</span>
            <Tooltip
                id={id}
                place={tooltipPlace}
                opacity={1}
                className="tooltip"
                border="1px solid #5e92ff"
            />
        </Link>
    );
};

export default IconLink;
